// extracted by mini-css-extract-plugin
module.exports = {"textContent":"RollBackPopup_textContent__2G452","okButton":"RollBackPopup_okButton__Z6I_g"};